import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";
import { RootState } from "../../../../store";
import { cloudChiprApi } from "../../../../../services/cloudchipr.api";
import { widgetDataNotFoundSelector } from "../../../selectors/widgets/common/widgetDataNotFoundSelector";

export const getCostBreakdownV2WidgetDataByWidgetIdThunk = createAsyncThunk(
  "dashboards/getCostBreakdownWidgetDataByWidgetIdV2",
  async (widgetId: string, { dispatch, getState }) => {
    const state = getState() as RootState;

    const { getUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetId } =
      cloudChiprApi.endpoints;

    const widgetNotFound = widgetDataNotFoundSelector(
      state,
      widgetId ?? "",
      "cost_breakdown",
    );
    try {
      await dispatch(
        getUsersMeOrganisationsCurrentWidgetsCostBreakdownByWidgetId.initiate(
          {
            widgetId,
          },
          {
            forceRefetch: true,
          },
        ),
      );
    } catch (e) {
      if (!widgetNotFound) {
        // @ts-expect-error todo: api fix
        const errMessage = e?.data?.message || "Something went wrong";
        enqueueSnackbar(errMessage, {
          variant: "snackbarAlert",
          AlertSnackBarProps: { severity: "error" },
        });
      }
    }
  },
);
